import { render, staticRenderFns } from "./PageAccessFamily.vue?vue&type=template&id=644cfc5c&scoped=true&"
import script from "./PageAccessFamily.vue?vue&type=script&lang=js&"
export * from "./PageAccessFamily.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessFamily.vue?vue&type=style&index=0&id=644cfc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644cfc5c",
  null
  
)

export default component.exports